export const catalogMat = Signalman.featureFlag('catalog_mat');
export const newProductCard = Signalman.featureFlag('pc_new_product_card_v3');
export const internalNewProductCard = Signalman.featureFlag(
  'pc_internal_new_product_card_v1'
);

export const pricingValuePropsPdpTest = Signalman.featureFlag(
  'pc_pdp_value_props_test_v4'
);

export const algoliaRecommendations = Signalman.featureFlag(
  'pc_algolia_recommendations_v1'
);

export const unitPriceDisplayTestFeatureFlag = Signalman.featureFlagFromCookie(
  'pc_unit_price_display_test_v0'
);

export const elevateDecoFilterTest = Signalman.featureFlag(
  'pc_elevate_deco_filter_v1'
);

export const unbundledPriceTest = Signalman.featureFlag(
  'pc_unbundled_price_test_v0'
);
